import api from './api.ts';

export interface TranscriptionChunkResult {
  text: string;
  startMs?: number;
  endMs?: number;
  speaker?: string;
}

/**
 * Self-hosted Whisper STT’ye ses chunk’ı gönderir.
 * Servis yoksa null döner (tutanak yine kaydedilir).
 */
export async function transcribeAudioChunk(params: {
  meetingId: string;
  blob: Blob;
  filename?: string;
  speakerHint?: string;
  language?: string;
}): Promise<TranscriptionChunkResult | null> {
  const form = new FormData();
  form.append('meetingId', params.meetingId);
  form.append('language', params.language || 'tr');
  if (params.speakerHint) form.append('speaker', params.speakerHint);
  const name =
    params.filename ||
    `chunk-${Date.now()}.${params.blob.type.includes('wav') ? 'wav' : 'webm'}`;
  form.append('audio', params.blob, name);

  try {
    const response = await api.post('/api/transcription/chunk', form, {
      timeout: 90_000,
      headers: { 'Content-Type': undefined },
      transformRequest: [
        (data, headers) => {
          if (data instanceof FormData && headers) {
            delete headers['Content-Type'];
          }
          return data;
        },
      ],
    });
    const data = response.data?.data || response.data;
    const text = typeof data?.text === 'string' ? data.text.trim() : '';
    if (!text) return null;
    return {
      text,
      startMs: data.startMs,
      endMs: data.endMs,
      speaker: data.speaker || params.speakerHint,
    };
  } catch (err) {
    console.warn('[TBKMeet] transcription API error:', err);
    return null;
  }
}
